import {
	ErrorEventEnum,
} from './enums';

const {
	SILENCE_EVENT,
} = ErrorEventEnum;

export const ErrorEventNameMap = {
	[SILENCE_EVENT]: '发送消息过于频繁 可稍后再试',
};
